import { cn } from '@repo/tailwind-config/tailwind.functions'
import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import React, { PropsWithChildren } from 'react'

type Props = {
  title: string
  titleColor?: TailwindColor
  actions?: React.ReactNode[]
  transparent?: boolean
  actionTableLabel?: React.ReactNode
  className?: string
}

const ActionTableWrapper: React.FC<PropsWithChildren<Props>> = ({
  title,
  titleColor = tailwindColors.primary.DEFAULT,
  actions,
  transparent,
  actionTableLabel,
  children,
  className
}) => {
  return (
    <div
      className={cn(
        'p-5 bg-white rounded-2xl border border-grey-light',
        {
          'bg-transparent, border-0': transparent
        },
        className
      )}
    >
      <div className="flex items-center gap-4 mobile:flex-col mobile:items-start mobile:gap-2">
        <Typography variant="text" color={titleColor}>
          {title}
        </Typography>
        {actions?.map((action, index) => (
          <div key={index}>{action}</div>
        ))}
      </div>
      <div className="h-3 mobile:h-2" />
      {actionTableLabel}
      <div className="h-3 mobile:h-2" />
      {children}
    </div>
  )
}

export default ActionTableWrapper
